import { CommonModule } from "@angular/common";
import { NgModule } from "@angular/core";
import { FlexLayoutModule } from "@angular/flex-layout";
import { FormsModule } from "@angular/forms";
import { MatButtonModule } from "@angular/material/button";
import { MatDialogModule } from "@angular/material/dialog";
import { MatIconModule } from "@angular/material/icon";
import { SafeHTMLPipeModule } from "app/shared/pipes/safeHtml";
import { MessageBoxDialogComponent } from "./messagebox-dialog.component";
import { MessageBoxDialogService } from "./messagebox-dialog.service";


@NgModule({
    imports: [
        CommonModule,
        FlexLayoutModule,
        FormsModule,
        MatButtonModule,
        MatDialogModule,
        MatIconModule,

        SafeHTMLPipeModule,
    ],

    declarations: [MessageBoxDialogComponent],
    exports: [MessageBoxDialogComponent],
    providers: [MessageBoxDialogService],
})
export class MessageBoxDialogModule {}